import { useTranslation } from "react-i18next";

import { faServer, faShieldHalved, faLock } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

const ITEM_ICONS = [faServer, faShieldHalved, faLock];

type SecurityItem = {
	title: string;
	description: string;
};

export default function LandingSecuritySection() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`questionnaire.landingSecurity.${key}`);

	const items = t("questionnaire.landingSecurity.items", {
		returnObjects: true,
	}) as SecurityItem[];

	return (
		<section className="w-full px-4 md:px-0">
			<div className="w-full max-w-[1420px] mx-auto py-16 sm:py-24 px-4 md:px-16 flex flex-col gap-12">
				<div className="flex flex-col items-center gap-4 text-center max-w-[820px] mx-auto">
					<span className="font-urbanist text-[13px] font-bold uppercase tracking-[0.12em] text-[#2AA216] bg-[#EAF7E7] border border-[#CDEBC6] rounded-full px-4 py-1.5">
						{ts("kicker")}
					</span>
					<h2 className="font-urbanist text-[34px] md:text-[40px] font-semibold leading-[120%] text-[#1D243C]">
						{ts("title")}
					</h2>
					<p className="font-urbanist text-[18px] font-normal leading-[150%] text-[#626373]">
						{ts("description")}
					</p>
				</div>

				<div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
					{items?.map((item, index) => (
						<div
							key={item.title}
							className="flex flex-col gap-4 rounded-2xl border border-[#E6E6EC] bg-white p-7 shadow-[0_2px_10px_rgba(13,23,55,0.04)]"
						>
							<div className="flex w-12 h-12 shrink-0 rounded-xl bg-[#EAF7E7] justify-center items-center">
								<Icon className="w-5 h-5 text-[#2AA216]" icon={ITEM_ICONS[index]} />
							</div>
							<h3 className="font-urbanist text-[20px] font-bold text-[#1D243C] leading-[130%]">
								{item.title}
							</h3>
							<p className="font-urbanist text-[15px] leading-[160%] text-[#626373]">
								{item.description}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
